import { httpRequest, endpoint } from "@cirrus/core/http"

export const customerInfoGET = async (customerName) =>
  await httpRequest.get(endpoint.withRoot(`/api/v1/customer/${customerName}/info`))
